<template>
  <section id="news-latter" class="text-center padd-tb85">
    <div class="container main-container">
      <div class="row">  
        <div class="col-md-12">
           <h1 class="font-bold  mar-no blue-c-1">Subscribe for Updates</h1>
           <h6 class="mar-no blue-c-1 font-light padd-t10">Subscribe to our mail list for recent updates</h6>
           <div id="form-result2"></div>
           <form id="subcribe-form" name="subcribe-form" @submit.prevent="processForm" class="padd-t30">
             <div class="form_controler w1_">
                <input type="email" name="email" value="" id="nemail" placeholder="Email Address *" class="scontroler"  v-validate="'required|email'">
                <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
              </div>
              <div class="form_controler w2_ marg-t25">
                <input type="text" name="first_name" value="" id="nfname" placeholder="First Name *" class="scontroler"   v-validate="'required'">
                <span v-show="errors.has('first_name')" class="help is-danger">{{ errors.first('first_name') }}</span>
              </div><div class="form_controler  w2_ marg-t25">
                <input type="text" name="last_name" value="" id="nlname" placeholder="Last Name *" class="scontroler"   v-validate="'required'">
                <span v-show="errors.has('last_name')" class="help is-danger">{{ errors.first('last_name') }}</span>
              </div>
              <div class="form_controler w1_ g-recaptcha" style="text-align:center;">
                   <vue-recaptcha sitekey="6LcVxrEUAAAAADs2q17NSpuTo9YEMI361EVDCW3J"  :loadRecaptchaScript="true"></vue-recaptcha>
              </div>
              <div class="form_controler btn_ padd-t30">
                <button class="btn btn_blue white-c btn_big" id="SubmitContact2">Subscribe</button>
              </div>
           </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import * as $ from 'jquery'

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VeeValidate);

export default{
  name: 'Subscribe',
  components: {
    VueRecaptcha
  },
  methods: {
    processForm: function() {

        this.$validator.validateAll().then((result) => {
        if (result) {
            //alert("success");
      
              //replace submit button with loader
              $( "#SubmitContact2" ).fadeOut('fast', function(){
                  $( '<img src="'+ require('./../../static/images/loader.gif') +'" id="loader_gif" />' ).insertAfter(this);
              });

              // Send the data using post
              var form = $( "#subcribe-form" );  
              var posting = $.post('https://danadvance.com/cash/ajax/newsletter-subscribe.php', form.serialize() );

              // Put the results in a div
              posting.done(function( data ) {
                var obj = $.parseJSON(data);
                $( "#form-result2" ).empty().append( obj.msg );
                if(obj.success == 'true')
                {
                  //success
                  form.find("input[type=text], input[type=email], input[type=tel], input[type=number], textarea").val("");//reset
                }
                $( "#SubmitContact2" ).fadeIn('fast', function(){
                  $( '#loader_gif' ).remove();
                  grecaptcha.reset();
                });
              });

        }
        });      
    }
  }
}
</script>
<style>
.g-recaptcha > div > div {
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Subscribe.vue